<template>
  <div
    v-if="showButtons"
    class="flex justify-between h-16 border-t border-zt-dark-200"
    :style="[firstLoginCustomParamsFields.styles.commerceInfo.bgColor]"
  >
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://community.sichern.com/t5/Sabias-que/POLITICA-DE-PRIVACIDAD-DE-LA-PLATAFORMA-SICHERN/ta-p/567941"
      class="text-zt-dark-300 flex items-center justify-center border-r"
      :style="[
        firstLoginCustomParamsFields.styles.commerceInfo.textColor
      ]"
    >
      <p>{{ $t('message.loginComponent.login.termsAndConditions') }}</p>
    </a>
    <a
      @click="activeModalInfo"
      class="text-zt-dark-300 flex items-center justify-center"
      :style="[
        firstLoginCustomParamsFields.styles.commerceInfo.textColor
      ]"
    >
      <p>{{ $t('message.loginComponent.login.help') }}</p>
    </a>
  </div>
</template>

<script>
export default {
  name: 'ztAuthLoginCommercialHelp',
  inject: ['mutation'],
  props: {
    firstLoginCustomParamsFields: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    showButtons() {
      return typeof this.firstLoginCustomParamsFields.styles.commerceInfo
        .showButtons !== 'undefined' &&
        this.firstLoginCustomParamsFields.styles.commerceInfo.showButtons !== ''
        ? this.firstLoginCustomParamsFields.styles.commerceInfo.showButtons
        : true
    }
  },
  methods: {
    activeModalInfo() {
      this.mutation.setActiveModal(true)
    }
  }
}
</script>

<style scoped></style>
